import { useTranslation } from 'react-i18next'

export default function FormattedHours({ value }) {

    const { t } = useTranslation()

    return `${ value } ${ t('labourHours', 'hours') }`

}